/* You must register this file at "website\src\i18n\en-us" */

export default {
    /* Global Vocabulary */


    /* Module special vocabulary */
    countries: {
        menu: {
            index: 'Countries',
            create: 'New country',
            list: 'Countries'
        },
        table_titles: {
            id: 'ID',
            name: 'Name',
            acronym: 'Two-letter Abbreviation',
            acronym3: 'Three-Letter Abbreviation',
            calling_code: 'Calling code',
            currency_acronym: 'Currency',
            reward_amount_of_new_user: 'Reward Amount Of New User',
            reward_amount_of_old_user: 'Reward Amount Of Old User',
            reward_min_transfer_amount: 'Reward Min Transfer Amount',
            currency: 'Currency',
            is_for_secondary_currency: "Secondary currency",
            has_acceptable_id_document: "ID document accepted",
            risk_rating: 'Risk rating',
            setting: 'Edit / Delete',
        },
        edit: 'Edit Country'
    }
}
